<template>
  <div>
    <a-card style="width: 100%">
      <a-row :gutter="[12, 24]">
        <a-col :sm="{ span: 24 }" :md="{ span: 24 }" :xl="{ span: 12 }">
          <a-form :layout="formLayout" style="margin-top: 10%">
            <a-form-item
              label="Type"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-select defaultValue="genename">
                <a-select-option value="genename">
                  Gene Symbol
                </a-select-option>
                <a-select-option value="ensgId"> Ensembl ID </a-select-option>
                <a-select-option value="ncbi"> Entrez ID </a-select-option>
                <a-select-option value="alias"> Alias </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item
              label="Species"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-select defaultValue="Human">
                <a-select-option value="Human"> Human </a-select-option>
                <a-select-option value="Mouse"> Mouse </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <span slot="label"> <span style="color: red">*</span> Input</span>
              <a-input placeholder="CUL3" v-model="tempgene" />
            </a-form-item>
            <a-form-item :wrapper-col="buttonItemLayout.wrapperCol">
              <a-button type="primary" @click="submit('#searchSC')">
                Submit
              </a-button>
            </a-form-item>
          </a-form>
        </a-col>
        <a-col :sm="{ span: 24 }" :md="{ span: 24 }" :xl="{ span: 12 }"
          ><div id="genecount" :style="{ width: '100%', height: '350px' }"></div
        ></a-col>
        <a-col
          :sm="{ span: 24 }"
          :md="{ span: 24 }"
          :xl="{ span: 24 }"
          id="search1"
          ><searchResult
            v-show="this.perturbShow"
            style="margin-top: 15px"
            v-bind:perturbedgene="this.perturbedgene"
        /></a-col>
      </a-row>
    </a-card>
  </div>
</template>
<script>
import searchResult from "./resultTable/searchSC.vue";

export default {
  components: { searchResult },
  data() {
    return {
      formLayout: "horizontal",
      tempgene: "",
      perturbedgene: "",
      xaxis: ["Human", "Mouse"],
      yaxis: [15000, 3000],
      perturbShow: false,
    };
  },
  mounted() {
    this.drawgenecount(this.xaxis, this.yaxis);
  },
  computed: {
    formItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
          }
        : {};
    },
    buttonItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            wrapperCol: { span: 14, offset: 4 },
          }
        : {};
    },
  },
  methods: {
    drawgenecount(gene, percent) {
      // 基于刚刚准备好的 DOM 容器，初始化 EChart 实例
      let myChart = this.$echarts.init(document.getElementById("genecount"));
      // 绘制图表
      myChart.setOption({
        title: { text: "Numbe of gene perturbations per species[For example]" },
        tooltip: {},
        height: 250,
        // width:"100%",
        // height:"290px",
        xAxis: {
          axisLabel: {
            // rotate: -45,
            color: "black",
          },
          data: gene,
        },
        yAxis: {},
        series: [
          {
            name: "No. of genes",
            type: "bar",
            data: percent,
          },
        ],
      });
      //随着窗口的拖动,图自适应窗口的大小
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
    submit(idname) {
      if (this.tempgene == "") {
        this.$message.warning("Input can not be empty, please check!", 3);
        this.perturbShow = false;
      } else {
        //this.$message.success(this.perturbedgene, 3);
        this.perturbedgene = this.tempgene;
        this.perturbShow = true;
        document.querySelector(idname).scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      }
    },
    handleFormLayoutChange(e) {
      this.formLayout = e.target.value;
    },
  },
};
</script>
<style scpoed></style>
